import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map, Observable, shareReplay, switchMap } from 'rxjs';
import { updateEvent } from '@app/main/main-screen/store/data/events/events.actions';
import { ProjectUsersApiService } from '@app/api/services/project-users-api.service';
import { selectMainProjectId } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';

@Injectable({ providedIn: 'root' })
export class LeakDetectionEventsAssigneeService {
  private store = inject(Store);
  private projectUsersApiService = inject(ProjectUsersApiService);

  public assignableUsers$: Observable<string[]> = this.store.select(selectMainProjectId).pipe(
    filter((projectId): projectId is string => !!projectId),
    distinctUntilChanged(),
    switchMap(projectId =>
      this.projectUsersApiService
        .getByProjectId(projectId, { assignableToEvents: true })
        .pipe(map(response => response.data.map(user => user.userName)))
    ),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  private readonly projectId = this.store.selectSignal(selectMainProjectId);

  public changeAssignee(eventId: string, assignedTo: string | null): void {
    const projectId = this.projectId();

    if (!projectId) return;

    this.store.dispatch(updateEvent({ requestId: crypto.randomUUID(), projectId, eventId, data: { assignedTo } }));
  }
}
